module.exports = __webpack_public_path__ + "img/audioPlayer.4d5854d2.png";